import { ServiceLocator } from '../../app/ServiceLocator';
import { Formatters, Messages } from '../../codegen/Localize';
import { L10n } from '../../ts/L10n/L10n';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { Set } from '../../ts/models/Set';
import { ServerUsers } from '../../ts/resources/ServerUsers';
import { SiteUsers } from '../../ts/resources/SiteUsers';
import { IServerUser } from '../../ts/ServerApi/types/IServerUser';
import { IUserActionResult } from '../../ts/ServerApi/types/IUserActionResult';
import { openConfirmActionDialog } from '../../ts/services/ReactConfirmActionDialog';
import { ReactConfirmActionStringBody, ReactConfirmActionStringBodyProps } from '../../ts/services/ReactConfirmActionStringBody';
import { ServerService } from '../../ts/services/ServerService';
import { UserActionNotification, UserActionNotificationParams } from './notifications/UserActionNotification';

function showRemoveUsersFromSiteDialog(siteUsersToRemove: Set<ISiteUserInfo>): ng.IPromise<any> {

  const ServerService = ServiceLocator.get<ServerService>('ServerService');
  const SiteUsers = ServiceLocator.get<SiteUsers>('SiteUsers');
  const userActionNotification: UserActionNotification = UserActionNotification.instance;

  const siteUserDisplayText = Messages.confirmRemoveUsersFromSite({
    USER_NAME: L10n.elideIfLong(siteUsersToRemove.first().displayName),
    USER_COUNT: siteUsersToRemove.size(),
    SITE_NAME: L10n.elideIfLong(ServerService.sessionSiteName()),
    USER_COUNT_LOC: Formatters.formatCount(siteUsersToRemove.size())
  });

  const dialogInstance = openConfirmActionDialog<ReactConfirmActionStringBodyProps, any, IUserActionResult>({
    title: Messages.removeUser(),
    bodyComponent: ReactConfirmActionStringBody,
    initialBodyProps: {
      message: siteUserDisplayText
    },
    initialDialogState: {},
    actionName: Messages.removeUserAction({ITEM_COUNT: siteUsersToRemove.size()}),
    action: () => SiteUsers.deleteUsers(siteUsersToRemove.keys()),
    isActionDelete: true
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: siteUsersToRemove,
      results: result.results,
      errors: result.errors,
      successCode: '13',
    };
    userActionNotification.notify(params);
  });

  return dialogInstance.result;
}

function showDeleteUsersFromServerDialog(serverUsersToRemove: Set<IServerUser>): ng.IPromise<any> {

  const ServerUsers = ServiceLocator.get<ServerUsers>('ServerUsers');
  const userActionNotification = UserActionNotification.instance;

  const serverUserDisplayText = Messages.confirmDeleteUsers({
    USER_NAME: L10n.elideIfLong(serverUsersToRemove.first().displayName),
    USER_COUNT: serverUsersToRemove.size(),
    USER_COUNT_LOC: Formatters.formatCount(serverUsersToRemove.size())
  });

  const dialogInstance = openConfirmActionDialog<ReactConfirmActionStringBodyProps, any, IUserActionResult>({
    title: Messages.removeUser(),
    bodyComponent: ReactConfirmActionStringBody,
    initialBodyProps: {
      message: serverUserDisplayText
    },
    initialDialogState: {},
    actionName: Messages.removeUserAction({ITEM_COUNT: serverUsersToRemove.size()}),
    action: () => ServerUsers.deleteUsers(serverUsersToRemove.keys()),
    isActionDelete: true
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: serverUsersToRemove,
      results: result.results,
      errors: result.errors,
      successCode: '11',
    };
    userActionNotification.notify(params);
  });

  return dialogInstance.result;
}

export const RemoveUsersAction = {
  showRemoveUsersFromSiteDialog,
  showDeleteUsersFromServerDialog
};

